import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Translation from "../../services/translation.service";
import StorefrontTitle from "./storefront-title.component";
import Helpers from "../../helpers/shared.helper";

const subscriptions = [];
const ContentSlider = ({ imagesFolder, sliderData, closeModal }) => {
    let lang = Translation.getCurrentLanguage();
    const sliderRef = useRef();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [translationKeys, setTranslationsKeys] = useState(
        Translation.keys ? Translation.keys : {}
    );

    const gotoNext = () => {
        sliderRef.current.slickNext();
    }

    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        adaptiveHeight: true,
        currentSlide: 0,
        rtl: lang === "en" ? false : true,
        arrows: false,
        // appendDots: dots => <ul>{dots}</ul>,
        customPaging: (i) => <div> </div>,
    };


  useEffect(() => {
    subscriptions.push(
      Translation.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );
    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []);

  return (
    // <div className="contentSliderContainer">
    <>
      {sliderData && sliderData.length > 0 &&
      <div className="contentSlider">
          <Slider {...settings} ref={sliderRef} beforeChange={(...args) => {
              setCurrentIndex(args[1]);
            }}>
              {sliderData.map((item, index) => {
              return (
                  <div className="contentSlider-slide" key={index}>
                      {item?.image && <img
                          src={Helpers.getPOImageCommon(imagesFolder, item?.image, Translation.activeLang, "") || ""}
                          alt=""
                      />}
                      <StorefrontTitle
                          title={translationKeys[item?.title]}
                          desc={translationKeys[item?.description]}
                      />
                  </div>);
              })}
          </Slider>
          {currentIndex + 1 !== sliderData.length ? 
              <button className="storefront-button" onClick={gotoNext}>{translationKeys["stm_info_modal_continue"]}</button>
              :
              <button className="storefront-button" onClick={(e) => closeModal(e)}>{translationKeys["stm_info_modal_got_it"]}</button>
          }
      </div>}
      <>
        {currentIndex + 1 !== sliderData.length ? 
              <button className="storefront-button onlyMobile" onClick={gotoNext}>{translationKeys["stm_info_modal_continue"]}</button>
              :
              <button className="storefront-button onlyMobile" onClick={(e) => closeModal(e)}>{translationKeys["stm_info_modal_got_it"]}</button>
          }
      </>
    {/* </div> */}
    </>
  );
};
export default ContentSlider;
